import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-611c79ab"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OkInvoiceContent" }
const _hoisted_2 = { class: "OkInvoiceContent__information" }
const _hoisted_3 = { class: "information__container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Общая информация", -1))
const _hoisted_5 = { class: "container__content" }
const _hoisted_6 = { class: "content__row" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Компания", -1))
const _hoisted_8 = { class: "row__value" }
const _hoisted_9 = { class: "content__row" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Тип доставки", -1))
const _hoisted_11 = { class: "row__value" }
const _hoisted_12 = { class: "content__row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Направление", -1))
const _hoisted_14 = { class: "row__value" }
const _hoisted_15 = { class: "content__row" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Объемный вес", -1))
const _hoisted_17 = { class: "row__value" }
const _hoisted_18 = { class: "content__row" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Физический вес", -1))
const _hoisted_20 = { class: "row__value" }
const _hoisted_21 = { class: "content__row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Количество мест", -1))
const _hoisted_23 = { class: "row__value" }
const _hoisted_24 = { class: "content__row" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Наименование товара", -1))
const _hoisted_26 = { class: "row__value" }
const _hoisted_27 = { class: "content__row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Номер накладной заказчика", -1))
const _hoisted_29 = { class: "row__value" }
const _hoisted_30 = { class: "content__row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Менеджер", -1))
const _hoisted_32 = { class: "row__value" }
const _hoisted_33 = { class: "content__row" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Кто создал", -1))
const _hoisted_35 = { class: "row__value" }
const _hoisted_36 = { class: "content__row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Коробка", -1))
const _hoisted_38 = { class: "row__value" }
const _hoisted_39 = { class: "information__container" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Оплата", -1))
const _hoisted_41 = { class: "container__content" }
const _hoisted_42 = { class: "content__row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Плательщик", -1))
const _hoisted_44 = { class: "row__value" }
const _hoisted_45 = { class: "content__row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Способ оплаты", -1))
const _hoisted_47 = { class: "row__value" }
const _hoisted_48 = { class: "content__row" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Наложенный платеж", -1))
const _hoisted_50 = { class: "row__value" }
const _hoisted_51 = { class: "content__row" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Стоимость перевозки", -1))
const _hoisted_53 = { class: "row__value" }
const _hoisted_54 = { class: "information__container" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Страхование груза", -1))
const _hoisted_56 = { class: "container__content" }
const _hoisted_57 = { class: "content__row" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Название груза", -1))
const _hoisted_59 = { class: "row__value" }
const _hoisted_60 = { class: "content__row" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Объявленная стоимость", -1))
const _hoisted_62 = { class: "row__value" }
const _hoisted_63 = { class: "information__container" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Дополнительная информация", -1))
const _hoisted_65 = { class: "container__content" }
const _hoisted_66 = { class: "content__row" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Контрольная дата прибытия", -1))
const _hoisted_68 = { class: "row__value" }
const _hoisted_69 = { class: "content__row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Дата создания", -1))
const _hoisted_71 = { class: "row__value" }
const _hoisted_72 = { class: "content__row" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Примечание к отправке", -1))
const _hoisted_74 = { class: "row__value" }
const _hoisted_75 = { class: "content__row" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Температурный режим", -1))
const _hoisted_77 = { class: "row__value" }
const _hoisted_78 = { class: "content__row" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Опасный груз", -1))
const _hoisted_80 = { class: "row__value" }
const _hoisted_81 = { class: "information__container" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Отправитель", -1))
const _hoisted_83 = { class: "container__content" }
const _hoisted_84 = { class: "content__row" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Наименование", -1))
const _hoisted_86 = { class: "row__value" }
const _hoisted_87 = { class: "content__row" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Контактное лицо", -1))
const _hoisted_89 = { class: "row__value" }
const _hoisted_90 = { class: "content__row" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Адрес", -1))
const _hoisted_92 = { class: "row__value" }
const _hoisted_93 = { class: "content__row" }
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Комментарий", -1))
const _hoisted_95 = { class: "row__value" }
const _hoisted_96 = { class: "content__row" }
const _hoisted_97 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Дата забора", -1))
const _hoisted_98 = { class: "row__value" }
const _hoisted_99 = { class: "content__row" }
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Самопривоз", -1))
const _hoisted_101 = { class: "row__value" }
const _hoisted_102 = { class: "content__row" }
const _hoisted_103 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Сектор", -1))
const _hoisted_104 = { class: "row__value" }
const _hoisted_105 = { class: "information__container" }
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Получатель", -1))
const _hoisted_107 = { class: "container__content" }
const _hoisted_108 = { class: "content__row" }
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Наименование", -1))
const _hoisted_110 = { class: "row__value" }
const _hoisted_111 = { class: "content__row" }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Контактное лицо", -1))
const _hoisted_113 = { class: "row__value" }
const _hoisted_114 = { class: "content__row" }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Адрес", -1))
const _hoisted_116 = { class: "row__value" }
const _hoisted_117 = { class: "content__row" }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Комментарий", -1))
const _hoisted_119 = { class: "row__value" }
const _hoisted_120 = { class: "content__row" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Дата забора", -1))
const _hoisted_122 = { class: "row__value" }
const _hoisted_123 = { class: "content__row" }
const _hoisted_124 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Самовывоз", -1))
const _hoisted_125 = { class: "row__value" }
const _hoisted_126 = { class: "content__row" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Сектор", -1))
const _hoisted_128 = { class: "row__value" }
const _hoisted_129 = { class: "information__container" }
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container__title" }, "Информация о доставке", -1))
const _hoisted_131 = { class: "container__content" }
const _hoisted_132 = { class: "content__row" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row__title" }, "Проблемы", -1))
const _hoisted_134 = { class: "OkInvoiceContent__statuses" }
const _hoisted_135 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "statuses__title" }, "Статус накладной", -1))
const _hoisted_136 = { class: "statuses__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_ok_invoice_statuses = _resolveComponent("ok-invoice-statuses")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.invoice.company_name || 'Не указана'), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.invoice.shipment_type || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.invoice.direction || 'Не указано'), 1)
          ]),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.invoice.volume_weight || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.invoice.weight || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.invoice.places || 'Не указано'), 1)
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.invoice.product_name || 'Не указано'), 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.invoice.dop_invoice_number || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              (
                                    _ctx.invoice.manager &&
                                    (_ctx.invoice.manager.email || _ctx.invoice.manager.name)
                                )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.manager.email || _ctx.invoice.manager.name), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.invoice.created_by || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.invoice.size_type || 'Не указана'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_39, [
        _hoisted_40,
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _hoisted_43,
            _createElementVNode("div", _hoisted_44, [
              (_ctx.invoice.payment_type)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.payment_type) + " " + _toDisplayString(_ctx.invoice.payer_company ? `(${_ctx.invoice.payer_company})` : ''), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.invoice.payment_method || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_48, [
            _hoisted_49,
            _createElementVNode("div", _hoisted_50, _toDisplayString(_ctx.invoice.cod_payment || 'Не указан'), 1)
          ]),
          _createElementVNode("div", _hoisted_51, [
            _hoisted_52,
            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.getCostPrediction()), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_54, [
        _hoisted_55,
        _createElementVNode("div", _hoisted_56, [
          _createElementVNode("div", _hoisted_57, [
            _hoisted_58,
            _createElementVNode("div", _hoisted_59, _toDisplayString(_ctx.invoice.cargo_name || 'Не указано'), 1)
          ]),
          _createElementVNode("div", _hoisted_60, [
            _hoisted_61,
            _createElementVNode("div", _hoisted_62, _toDisplayString(_ctx.invoice.declared_price || 'Не указана'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_63, [
        _hoisted_64,
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("div", _hoisted_68, [
              (_ctx.clientSlaDate)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.clientSlaDate) + " (резерв +12 часов) ", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указана ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_69, [
            _hoisted_70,
            _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.invoice.created_at || 'Не указана'), 1)
          ]),
          _createElementVNode("div", _hoisted_72, [
            _hoisted_73,
            _createElementVNode("div", _hoisted_74, _toDisplayString(_ctx.invoice.annotation || 'Не указана'), 1)
          ]),
          _createElementVNode("div", _hoisted_75, [
            _hoisted_76,
            _createElementVNode("div", _hoisted_77, [
              (_ctx.invoice.temperature_regime)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.temperature_regime.title), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_78, [
            _hoisted_79,
            _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.invoice.is_dangerous ? 'Да' : 'Нет'), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_81, [
        _hoisted_82,
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _hoisted_85,
            _createElementVNode("div", _hoisted_86, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.title || 'Не указано'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_87, [
            _hoisted_88,
            _createElementVNode("div", _hoisted_89, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.invoice.sender.full_name), 1),
                    _createElementVNode("p", null, [
                      (_ctx.invoice.sender.additional_phone)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone) + ", " + _toDisplayString(_ctx.invoice.sender.additional_phone), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.invoice.sender.phone), 1)
                          ], 64))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указано")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_90, [
            _hoisted_91,
            _createElementVNode("div", _hoisted_92, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.full_address || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_93, [
            _hoisted_94,
            _createElementVNode("div", _hoisted_95, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.comment || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_96, [
            _hoisted_97,
            _createElementVNode("div", _hoisted_98, _toDisplayString(_ctx.takeDate || 'Не указана'), 1)
          ]),
          _createElementVNode("div", _hoisted_99, [
            _hoisted_100,
            _createElementVNode("div", _hoisted_101, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.self_delivery ? 'Да' : 'Нет'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указан")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_102, [
            _hoisted_103,
            _createElementVNode("div", _hoisted_104, [
              (_ctx.invoice.sender)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.sender.sectorName || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указан")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_105, [
        _hoisted_106,
        _createElementVNode("div", _hoisted_107, [
          _createElementVNode("div", _hoisted_108, [
            _hoisted_109,
            _createElementVNode("div", _hoisted_110, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.title || 'Не указано'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указано ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_111, [
            _hoisted_112,
            _createElementVNode("div", _hoisted_113, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.invoice.receiver.full_name), 1),
                    _createElementVNode("p", null, [
                      (_ctx.invoice.receiver.additional_phone)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone) + ", " + _toDisplayString(_ctx.invoice.receiver.additional_phone), 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.invoice.receiver.phone), 1)
                          ], 64))
                    ])
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указано")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_114, [
            _hoisted_115,
            _createElementVNode("div", _hoisted_116, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.full_address || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_117, [
            _hoisted_118,
            _createElementVNode("div", _hoisted_119, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.comment || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(" Не указан ")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_120, [
            _hoisted_121,
            _createElementVNode("div", _hoisted_122, _toDisplayString(_ctx.takeDate || 'Не указана'), 1)
          ]),
          _createElementVNode("div", _hoisted_123, [
            _hoisted_124,
            _createElementVNode("div", _hoisted_125, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.is_pickup ? 'Да' : 'Нет'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указан")
                  ], 64))
            ])
          ]),
          _createElementVNode("div", _hoisted_126, [
            _hoisted_127,
            _createElementVNode("div", _hoisted_128, [
              (_ctx.invoice.receiver)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.invoice.receiver.sectorName || 'Не указан'), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode("Не указан")
                  ], 64))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_129, [
        _hoisted_130,
        _createElementVNode("div", _hoisted_131, [
          _createElementVNode("div", _hoisted_132, [
            _hoisted_133,
            _createElementVNode("div", {
              class: _normalizeClass(["row__value", { 'cursor-pointer text-red-500': _ctx.problemsFailed }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onReloadProblems && _ctx.onReloadProblems(...args)))
            }, [
              (_ctx.problemsLoading)
                ? (_openBlock(), _createBlock(_component_loader, {
                    key: 0,
                    class: "primary"
                  }))
                : (_ctx.problemsFailed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode("Ошибка")
                    ], 64))
                  : (_ctx.problemsEmpty)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createTextVNode("Не указаны")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createTextVNode(_toDisplayString(_ctx.problems.join(', ')), 1)
                      ], 64))
            ], 2)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_134, [
      _hoisted_135,
      _createElementVNode("div", _hoisted_136, [
        _createVNode(_component_ok_invoice_statuses, {
          loading: _ctx.statusesLoading,
          failed: _ctx.statusesFailed,
          statuses: _ctx.statuses,
          onReload: _ctx.onReloadStatuses
        }, null, 8, ["loading", "failed", "statuses", "onReload"])
      ])
    ])
  ]))
}